const types = {
    SET_REPLENISHMENT_REPORT: '[REPLENISHMENT REPORT] SET REPLENISHMENT REPORT',
}

export {
    types
}